import type { PluginOption } from 'vite';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { WIX_CONFIG_FILENAME } from '@wix/cli-core-definitions';
import { getMonitoringVitePlugins } from '@wix/monitoring-buildtime';
import { getMonitoringProvider } from '../../app-manifest/monitoring.js';
import type { ProjectModel } from '../../model.js';

interface Options {
  initialModel: ProjectModel;
}

export function monitoring({ initialModel }: Options): PluginOption {
  const { monitoring } = initialModel.config;

  if (!monitoring) {
    return null;
  }

  try {
    return getMonitoringVitePlugins({
      appId: initialModel.config.appId,
      silent: true,
      provider: getMonitoringProvider(monitoring),
    });
  } catch (e) {
    throw new CliError({
      cause: e,
      code: CliErrorCode.FailedToCreateMonitoringVitePlugin({
        configPath: WIX_CONFIG_FILENAME,
      }),
    });
  }
}
